import * as v from 'valibot';

type HeaderConfigItem = {
  name: string;
  type?: 'link' | 'event';
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  value: string | HeaderConfigItem[];
  nested?: boolean;
  active?: boolean;
};

export const headerConfigItemSchema: v.BaseSchema<HeaderConfigItem> = v.object({
  name: v.string(),
  type: v.optional(v.union([v.literal('link'), v.literal('event')])),
  active: v.optional(v.boolean()),
  target: v.optional(
    v.union([
      v.literal('_blank'),
      v.literal('_self'),
      v.literal('_parent'),
      v.literal('_top'),
      v.literal('framename'),
    ]),
  ),
  value: v.union([v.string(), v.array(v.lazy(() => headerConfigItemSchema))]),
  disabled: v.optional(v.boolean()),
});

const searchBaseSchema = v.object({
   enabled: v.boolean()
});
const clientSearchSchema = v.object({
    ...searchBaseSchema.entries,
    type: v.optional(v.literal('client'))
})
export const serverSearchSchema = v.object({
    ...searchBaseSchema.entries,
    type: v.optional(v.literal('server')),
    domain: v.optional(v.union([v.literal('cp'), v.literal('bo')]))
})
export const headerConsumerSchema = v.object({
  search: v.optional(v.union([clientSearchSchema, serverSearchSchema])),
  notifications: v.optional(v.object({ enabled: v.boolean() })),
  chat: v.optional(v.object({ enabled: v.boolean() })),
  goto: v.optional(
    v.object({
      enabled: v.boolean(),
      consumerItem: v.optional(v.union([headerConfigItemSchema,v.array(headerConfigItemSchema)])),
    }),
  ),
  items: v.array(headerConfigItemSchema),
});

export const headerBrandingSchema = v.object({
  primaryColor: v.string(),
  navColor: v.string(),
  logoUrl: v.string(),
});

export const headerConfigSchema = v.object({
  logo: v.optional(
    v.object({
      src: v.string(),
      alt: v.string(),
    }),
  ),
  search: v.object({ enabled: v.boolean() }),
  notifications: v.object({ enabled: v.boolean() }),
  chat: v.object({ enabled: v.boolean() }),
  items: v.array(headerConfigItemSchema),
  gotoItems: v.object({ enabled: v.boolean() }),
});

export const headerActiveMenuItemSchema = v.object({
  activeItem: v.string(),
});
